/**
 * 
 * @param {*} fn 
 * @param {*} timeout 
 */
export const sleep = function (fn, timeout) {
    return new Promise(resolve =>{
        setTimeout(()=>{
            resolve(fn());
        }, timeout);
    })
}